import React, { useState } from 'react';
import { Form } from 'react-final-form';
import { Link, useHistory } from 'react-router-dom';
import Bluebird from 'bluebird';
import { Box, Grid, Container, Typography } from '@mui/material';
import routes from '../../routes';
import * as authService from '../../services/auth';
import * as authApi from '../../api/auth';
import { setValue } from '../../helpers/finalFormMutators';
import ConfirmationDialog from '../../components/ConfirmationDialog';
import ButtonWithLoading from '../../components/ButtonWithLoading';
import { useFormStyles } from './authStyles';
import loginLogo from '../../assets/svg/new-logo-with-title-white.svg';
import { Colors } from '../../assets/theme/Colors';
import SocialMediaLinkIcons from '../../components/SocialMediaLinkIcons';
import RFFTextField from '../../components/Common/RFFTextField';

const ForgotPasswordPage = () => {
  const authStyles = useFormStyles();
  const history = useHistory();
  const [isSubmitting, setSubmitting] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  let formMutator;

  // redirect to index if user is already logged in
  if (authService.getCurrentlyLoggedInUser()) {
    history.push(routes.index);
  }

  const onSubmit = values => {
    const { email } = values;

    setSubmitting(true);

    return Bluebird.try(() => authApi.forgotPassword(email))
      .then(res => res.json())
      .catch(() => true) // ignore any errors to not show information that might interest attackers...
      .finally(() => {
        setSubmitting(false);
        setShowDialog(true);

        formMutator('email', '');
      });
  };

  return (
    <Box sx={authStyles.pageBackground}>
      <Container maxWidth="md">
        {showDialog && (
          <ConfirmationDialog
            message="An email with instructions was sent. Please check your inbox."
            buttons={[{ label: 'Got it', onClick: () => history.push(routes.login) }]}
            closeDialog={() => setShowDialog(false)}
          />
        )}

        <Grid container spacing={2} sx={authStyles.pageContainer} data-testid="welcome-index-page">
          <Grid item xs sx={authStyles.logoWrapper}>
            <Box component="img" src={loginLogo} alt="logo" sx={authStyles.logo} />
          </Grid>
          <Grid item xs sx={authStyles.loginFormWrapper}>
            <Typography sx={authStyles.headerText} data-testid="signup-header">
              Password recovery
            </Typography>
            <Form
              mutators={{
                ...setValue,
              }}
              onSubmit={onSubmit}
              render={({ handleSubmit, submitting, pristine, invalid, dirtySinceLastSubmit, form, values }) => {
                formMutator = form.mutators.setValue;

                return (
                  <form style={authStyles.form} onSubmit={handleSubmit}>
                    <Box sx={authStyles.input}>
                      <RFFTextField
                        margin="normal"
                        name="email"
                        type="email"
                        variant="outlined"
                        fullWidth
                        placeholder="Email Address"
                        autoComplete="email"
                      />
                    </Box>

                    <ButtonWithLoading
                      sx={authStyles.submitButton}
                      fullWidth
                      type="submit"
                      isLoading={submitting || isSubmitting}
                      disabled={pristine || (invalid && !dirtySinceLastSubmit) || values.email.length === 0}
                    >
                      Send Reset Password Email
                    </ButtonWithLoading>
                  </form>
                );
              }}
            />
            <Grid container>
              <Grid item>
                <Link to={routes.login} variant="body2" style={{ color: Colors.white }}>
                  Already have an account? Login
                </Link>
              </Grid>
            </Grid>

            <Grid container direction="row" justifyContent="center" alignItems="center" sx={{ paddingTop: 2 }}>
              <SocialMediaLinkIcons iconColor="#fff" />
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default ForgotPasswordPage;
